module.exports = __webpack_public_path__ + "img/7.214efd0e.png";